import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import FieldText from "./../../common/FieldText";
import FieldSelect from "./../../common/FieldSelect";
import FieldMultiSelect from "./../../common/FieldMultiSelect";
import AutoReportAPI from '../../../api/AutoReportAPI';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';
import ApiUiController from '../../../controller/ApiUiController';
import ValidationController from '../../../controller/ValidationController';

class AutoReportList extends React.Component {

  constructor(props) {
    super(props);

    this.model = reactLocalStorage.getObject(Const.Model).auto_report;
    this.state = { inApiCall: true, show: false, reminders: [], reminder: null, inValid: { } };
    this.path = this.props.match.path

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) { AutoReportAPI.list(this.onReceived, this.onFail); } }
  
  onFail = () => this.setState({ inApiCall: false });

  onReceived = res => this.setState({ ...this.state, inApiCall: false, reminders: [ ...res.data ] });

  onEdit = index => this.setState({ ...this.state, reminder: { ...this.state.reminders[index] }, 
    show: true, inApiCall: false });
  
  confirmDelete = index => {
    const message = `Are you sure you want to delete to ${this.state.reminders[index].name}`;
    Util.confirmAlert('Delete', message, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      AutoReportAPI.delete(this.state.reminders[index].id, this.onDelete, this.onFail);
    });
  }
  onDelete = () => {
    Util.showNotification('Successful', 'Deleted successfully.', 'success');
    AutoReportAPI.list(this.onReceived, this.onFail);
  }

  onChange = (field, value) => {
    const reminder = this.state.reminder ? { ...this.state.reminder } : {};
    reminder[field] = value;

    /*
    reminder.field_pattern = (reminder && reminder.field_month ? reminder.field_month : '*')
      + ' ' + (reminder && reminder.field_day ? reminder.field_day : '*')
      + ' ' + (reminder && reminder.field_hr ? reminder.field_hr : '*')
      + ' ' + (reminder && reminder.field_min ? reminder.field_min : '*');
    */

    this.setState({ ...this.state, reminder });
  };

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.reminder);
    if (inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      AutoReportAPI.save(this.state.reminder, this.onSaved, this.onFail);
    } else {
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };

  onSaved = (res) => {
    Util.showNotification("Successful", "Reminder saved successfully", "success");
    this.setState({ ...this.state, inApiCall: false, show: false });
    AutoReportAPI.list(this.onReceived, this.onFail);
  };

  render() {
    const inValid = this.state.inValid;
    const reminder = this.state.reminder;
    const fields = this.model.fields;
    if (!this.List) return null;
    return (
      <>
        <Modal aria-labelledby="contained-modal-title-vcenter"
          size="md" show={this.state.show} className="w-660" centered
          onHide={() => this.setState({ ...this.state, show: false })}
          onExit={() => this.setState({ ...this.state, show: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              { !this.state.reminder || !this.state.reminder.id ? 'Add' : 'Update'} Report Automation
            </Modal.Title>
          </Modal.Header>

          <ApiUiController inApiCall={this.state.inApiCall}>
            <Modal.Body>
              <Form key="form">
                <div className="row">
                  <FieldText
                    key="name"
                    id="name"
                    field={fields.name}
                    value={reminder ? reminder.name : ''}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />
                </div>
                <div className="row">
                  <FieldSelect
                    key="field_month"
                    id="field_month"
                    field={fields.field_month}
                    value={reminder ? reminder.field_month : 0}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />

                  <FieldSelect
                    key="field_day"
                    id="field_day"
                    field={fields.field_day}
                    value={reminder ? reminder.field_day : 0}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />

                  <FieldSelect
                    key="field_hr"
                    id="field_hr"
                    field={fields.field_hr}
                    value={reminder ? reminder.field_hr : 0}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />

                  <FieldSelect
                    key="field_min"
                    id="field_min"
                    field={fields.field_min}
                    value={reminder ? reminder.field_min : 0}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />
                </div>

                <div className="row">
                  <FieldMultiSelect
                    key="reports"
                    id="reports"
                    field={fields.reports}
                    value={reminder ? reminder.reports : ''}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />

                  <FieldMultiSelect
                    key="users"
                    id="users"
                    field={fields.users}
                    value={reminder ? reminder.users : ''}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />
                </div>

                <div className="row">
                  <FieldSelect
                    key="template"
                    id="template"
                    field={fields.template}
                    value={reminder ? reminder.template : 0}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />

                  <FieldSelect
                    key="email_vendor"
                    id="email_vendor"
                    field={fields.email_vendor}
                    value={reminder ? reminder.email_vendor : 0}
                    onValueChange={this.onChange}
                    inValid={inValid}
                  />
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.onSave}>Submit</Button>
            </Modal.Footer>
          </ApiUiController>
        </Modal>
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 pb-3">
                <h3>Report Automation</h3>
              </div>
              <div className="col-md-6 text-right pb-3">
                {this.Add &&
                  <span to={`${this.path}/0`} className="buttons success"
                    onClick={() => this.setState({ ...this.state, show: true })}>
                    + Add Report Automation
                  </span>
                }
              </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Reporting</th>
                      <th>Month</th>
                      <th>Day</th>
                      <th>Hr</th>
                      <th>Min</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {this.state.reminders.map((reminder, _i) => (
                        <tr key={`reminder_${_i + 1}`}>
                          <td>{_i + 1}</td>
                          <td>{reminder.name}</td>
                          <td>{Display.FieldValue(reminder, 'users', this.model.fields)}</td>
                          <td>{Display.FieldValue(reminder, 'field_month', this.model.fields)}</td>
                          <td>{Display.FieldValue(reminder, 'field_day', this.model.fields)}</td>
                          <td>{Display.FieldValue(reminder, 'field_hr', this.model.fields)}</td>
                          <td>{Display.FieldValue(reminder, 'field_min', this.model.fields)}</td>
                          <td>
                            { this.Update
                              ? <span onClick={() => this.onEdit(_i)} className="buttons delete">
                                <FaPencilAlt /> Update
                              </span>
                              : null
                            }
                            { this.Delete
                              ? <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
                                <FaTrash /> Delete
                              </span>
                              : null
                            }
                          </td>
                        </tr>
                      ))}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(AutoReportList);
